// frontend/src/pages/Profile.tsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthApi } from '../hooks/use-auth-api';

const Profile: React.FC = () => {
  const { user, isAuthenticated, isLoading, logout } = useAuthApi();
  const navigate = useNavigate();
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({ name: '', phone: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/login');
      return;
    }

    if (user) {
      setForm({
        name: user.name || '',
        phone: user.phone || ''
      });
    }
  }, [user, isAuthenticated, isLoading, navigate]);

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    try {
      // در اینجا می‌توانید API بروزرسانی پروفایل را اضافه کنید
      // در حال حاضر فقط نمایشی است
      alert('پروفایل با موفقیت بروزرسانی شد!');
      setEditing(false);
    } catch (error) {
      alert('خطا در بروزرسانی پروفایل');
    }
    setSaving(false);
  };

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        ⏳ در حال بارگذاری...
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return null;
  }

  return (
    <div style={{ direction: 'rtl', padding: '20px', maxWidth: '700px', margin: '0 auto' }}>
      <div style={{ background: '#fff', borderRadius: '16px', padding: '30px', boxShadow: '0 2px 10px rgba(0,0,0,0.06)' }}>
        <h1 style={{ color: '#1e3a1e', fontSize: '24px', marginBottom: '20px' }}>📋 پروفایل من</h1>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '25px', padding: '20px', background: '#f5faf5', borderRadius: '12px' }}>
          <div style={{ 
            width: '80px', 
            height: '80px', 
            borderRadius: '50%', 
            background: '#2e7d32', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            fontSize: '32px',
            color: '#fff'
          }}>
            👤
          </div>
          <div>
            <h2 style={{ color: '#1e3a1e', margin: 0 }}>{user.name || 'کاربر'}</h2>
            <p style={{ color: '#888', margin: '5px 0 0' }}>📱 {user.phone}</p>
            <p style={{ color: '#888', fontSize: '13px' }}>نقش: {user.role === 'admin' ? 'مدیر' : user.role === 'manager' ? 'مدیر محتوا' : 'کاربر عادی'}</p>
          </div>
        </div>

        {editing ? (
          <form onSubmit={handleSave} style={{ marginBottom: '20px' }}>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', fontWeight: '600', marginBottom: '5px' }}>نام و نام خانوادگی</label>
              <input
                type="text"
                value={form.name}
                onChange={e => setForm({ ...form, name: e.target.value })}
                style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '2px solid #ddd' }}
              />
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button type="submit" style={{ padding: '10px 24px', background: '#2e7d32', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
                {saving ? '⏳ در حال ذخیره...' : '💾 ذخیره'}
              </button>
              <button type="button" onClick={() => setEditing(false)} style={{ padding: '10px 24px', background: '#e0e0e0', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
                انصراف
              </button>
            </div>
          </form>
        ) : (
          <div style={{ marginBottom: '20px' }}>
            <button onClick={() => setEditing(true)} style={{ padding: '10px 24px', background: '#2e7d32', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
              ✏️ ویرایش پروفایل
            </button>
          </div>
        )}

        <div style={{ borderTop: '1px solid #eee', paddingTop: '20px' }}>
          <h3 style={{ color: '#1e3a1e', marginBottom: '15px' }}>🔗 لینک‌های سریع</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Link to="/advertisements" style={{ color: '#2e7d32', textDecoration: 'none' }}>📢 مشاهده آگهی‌ها</Link>
            <Link to="/experiences" style={{ color: '#2e7d32', textDecoration: 'none' }}>🌾 مشاهده تجارب کشاورزان</Link>
            <Link to="/articles" style={{ color: '#2e7d32', textDecoration: 'none' }}>📰 مشاهده مقالات</Link>
            {user.role === 'admin' || user.role === 'manager' ? (
              <Link to="/admin/dashboard" style={{ color: '#f57c00', textDecoration: 'none', fontWeight: 'bold' }}>📊 رفتن به داشبورد مدیریت</Link>
            ) : null}
            <button onClick={logout} style={{ 
              padding: '10px 20px', 
              background: '#ffebee', 
              color: '#c62828', 
              border: 'none', 
              borderRadius: '8px', 
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              textAlign: 'right'
            }}>
              🚪 خروج از حساب کاربری
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;